import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "layer-checkbox__row" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = { class: "layer-checkbox__icon-wrapper" }
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    'layer-checkbox': true,
    'layer-checkbox--checked': _ctx.checked,
  })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({'layer-checkbox__input': true, 'layer-checkbox__input--checked': _ctx.checked})
      }, [
        _createElementVNode("input", {
          id: _ctx.label,
          title: "",
          type: "checkbox",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event))),
          checked: _ctx.checked,
          value: "checked"
        }, null, 40, _hoisted_2)
      ], 2),
      (_ctx.hasDefaultSlotContent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{'layer-checkbox__submodules-switcher--dark': _ctx.getContrastActive}, "layer-checkbox__submodules-switcher"]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submodulesToggle(_ctx.tabIndex)), ["stop"]))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "layer-checkbox__submodules-switcher-inside" }, [
              _createElementVNode("i", { class: "mdi mdi-chevron-down" })
            ], -1)
          ]), 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["layer-checkbox__icon", {'layer-checkbox__icon--active': _ctx.checked}]),
          style: _normalizeStyle(`mask: url(${_ctx.getIconUrl(_ctx.icon)}) no-repeat center;mask-size: contain;`)
        }, null, 6),
        _createElementVNode("label", {
          for: _ctx.label,
          class: _normalizeClass(["layer-checkbox__title", {'layer-checkbox__title--active': _ctx.checked}])
        }, [
          _createVNode(_component_translated_text_component, { translation: _ctx.label }, null, 8, ["translation"])
        ], 10, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
      'layer-checkbox__submodules': true,
      'layer-checkbox__submodules--show': _ctx.navActiveTab === _ctx.tabIndex
    })
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2)
  ], 2))
}